// import { Toast } from 'mint-ui'
import { getAccountId } from '@/utils/init/pubs'
import { appUser, encryptAES_H5, decryptAES_H5 } from '@/utils'
import { getPort } from '@/api/base'

const getAppNameUpper = () => getAccountId(appUser.isBrowser).toUpperCase()
let prefix_key
const prefix = () => {
  if (prefix_key != null) {
    return prefix_key
  }

  const value = getPort()
  prefix_key = value ? `[${value.toUpperCase()}] ` : ''
  return prefix_key
}

export const storage = {
  // a.1 手机登录
  loginCheckCode() {
    this.key = prefix() + `USER-LOGIN-CHECK-CODE`
    this.expireDay = 7
    return this
  },
  // a.2 用户登录KEY
  AppWeixinKey() {
    this.key = prefix() + `USER-WEIXIN-${getAppNameUpper()}` // 存储微信登录信息openid等
    this.expireDay = 365
    this.v = 2
    return this
  },
  // a.2 用户账号KEY
  AppUserKey() {
    this.key = prefix() + `USER-${getAppNameUpper()}`
    this.expireDay = 365
    return this
  },
  // a.2 账号强制切换标记（测试使用）
  AppUserKeySwitch() {
    this.key = prefix() + `USER-${getAppNameUpper()}__Switch`
    this.expireDay = 1
    return this
  },
  AccountErrorInfo() {
    this.key = prefix() + `USER-ACCOUNTERROR-INOF`
    this.expireDay = 1
    return this
  },
  // a.3 需要登录的页面路由
  loginNextHash() {
    this.key = prefix() + `USER-LOGIN-NEXT-HASH`
    this.expireDay = 7
    return this
  },
  // a.3 需要登录的操作
  loginNextAction() {
    this.key = prefix() + `USER-LOGIN-NEXT-ACTION`
    this.expireDay = 1
    return this
  },
  // b.1 支付结果
  PaymentPayStatus(goodsId) {
    this.key = prefix() + `USER-PAYMENT_PAYSTATUS-${goodsId}`
    this.expireDay = 365
    return this
  },
  // b.2 学习计划报名结果
  StudyplanApplyStatus(goodsId) {
    this.key = prefix() + `USER-STUDYPLAN_APPLYSTATUS-${goodsId}`
    this.expireDay = 30
    return this
  },
  // b.3 订单信息
  OrderMsg() {
    this.key = `USER-PAYMENT_ORDER`
    this.expireDay = 1
    return this
  },
  debugInfoShowConsole() {
    this.key = prefix() + `DEBUGINFO-SHOWCONSOLE`
    this.expireDay = 1
    return this
  },
  // c.1 替换路由
  replace(hash, { islogin } = {}) {
    if (location.hash !== hash) {
      // Toast('location.hash = ' + hash)
      console.log('[Init] appUser.replace', location.hash, '->', hash)
      // 登录时切换
      if (islogin) {
        location.hash = hash // location.replace(URL)
      }
      appUser.toView = hash
    }
  },
  // GET SET Item
  getItem() {
    let item = JSON.parse(localStorage.getItem(this.key) || '{}')

    console.log(item, this.key, localStorage.getItem(this.key), ';;;')
    if (typeof item !== 'object') {
      return item
    }
    // 检查有效期
    const { _expire } = item
    if (_expire && new Date(_expire) < new Date()) {
      item = {}
      console.log('Item过期了', item)
      this.remove()
    }
    if (!item.v && item.v !== 2) {
      console.log('Item版本不一致', item)
      // 解密敏感字段
      try {
        if (item.openId) item.openId = encryptAES_H5(item.openId)
      } catch (e) {}

      try {
        if (item.wxOpenId) item.wxOpenId = encryptAES_H5(item.wxOpenId)
      } catch (e) {}
      try {
        if (item.unionId) item.unionId = encryptAES_H5(item.unionId)
      } catch (e) {}
      try {
        if (item.wxUnionId) item.wxUnionId = encryptAES_H5(item.wxUnionId)
      } catch (e) {}
      try {
        if (item.areaCode) item.areaCode = encryptAES_H5(item.areaCode)
      } catch (e) {}
      try {
        if (item.mobileNumber) item.mobileNumber = encryptAES_H5(item.mobileNumber)
      } catch (e) {}
      item.v = 2
      localStorage.setItem(this.key, JSON.stringify(item))
    }
    return item
  },
  setItem(data) {
    console.log(data, 'data113')
    if (data == null) return
    if (typeof data === 'object' && this.expireDay) {
      const expire = new Date()
      expire.setDate(expire.getDate() + (parseInt(this.expireDay) || 1))
      data._expire = expire.getTime()
    }
    if (typeof data === 'object' && this.v) {
      data.v = this.v
    }

    localStorage.setItem(this.key, JSON.stringify(data))
  },
  remove() {
    localStorage.removeItem(this.key)
  }
}

export const pageHashs = {
  login: '#/login',
  home: '#/home'
}
